// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"d794c2d8","908":"d794c2d8","925":"1a91b8a0"}[chunkId] + ".chunk.css";
};